<template>
    <div v-if="!loading && hasAccess" class="clearfix pt-2 pb-4">
        <top-nav-bar goto="/documents">
            <button @click="navigateToEdit" v-if="document.crew_portal_visible && document.crew_portal_editable"
                    class="h-full items-center flex bg-secondary absolute pin-t pin-r mr-2 text-white font-bold font-heading uppercase">
                <i class="fas fa-pencil mr-2"></i>
                Edit
            </button>
        </top-nav-bar>

        <h3 class="text-center break-words">Document Details</h3>

        <list>
            <list-item class="text-base sm:text-xl">
                <template slot="icon">
                    <i class="fa text-blue text-xl" :class="getIcon()"></i>
                </template>
                <template slot="title">Type</template>
                <template slot="sub-title">{{document.type}}</template>
            </list-item>
            <list-item class="text-base sm:text-xl" v-if="document.expire_date">
                <template slot="icon">
                    <icon icon="far fa-clock" classes="text-blue w-6 h-6"></icon>
                </template>
                <template slot="title">Expiration Date</template>
                <template slot="sub-title">
                    {{document.expire_date ? formatDate(document.expire_date, 'DD.MM.YYYY') : 'N/A'}}
                </template>
            </list-item>
            <list-item class="text-base sm:text-xl">
                <template slot="icon">
                    <icon icon="far fa-file" classes="text-blue w-6 h-6"></icon>
                </template>
                <template slot="title">Status</template>
                <template slot="sub-title">
                    <div class="flex items-center">
                        <i class="fal text-lg mr-2" :class="findDocumentStatusIconStyles(document)"></i>
                        <span class="font-heading uppercase text-xs font-bold"
                              :class="findDocumentStatusStyles(document)">
                            {{document.status_name}}
                        </span>
                    </div>
                </template>
            </list-item>
            <list-item v-if="document.status === 'rejected'" class="text-base sm:text-xl">
                <template slot="icon">
                    <i class="fa fa-comment-exclamation text-blue text-xl"></i>
                </template>
                <template slot="title">Comment</template>
                <template slot="sub-title">{{document.reject_comment}}</template>
            </list-item>
        </list>

        <div class="block md:inline-flex md:float-right px-4">
            <a class="btn btn--colored__blue w-full text-center" :href="document_url" target="_blank"
               v-if="!$route.params.type && document.status_name !== 'Missing'">
                <i class="far fa-eye"></i>
                View
            </a>
        </div>
    </div>
    <div v-else class="h-full flex items-center justify-center">
        <div class="spinner-blue"></div>
    </div>
</template>

<script>
    import ShowsDocumentStatus from '../mixins/ShowsDocumentStatus';
    import InteractsWithDates from '@/mixins/InteractsWithDates';
    import auth from '../auth';
    import CanAccessView from "../mixins/CanAccessView";

    export default {
        mixins: [ShowsDocumentStatus, InteractsWithDates, CanAccessView],

        data() {
            return {
                document: {
                    id: '',
                    status: '',
                    crew_portal_visible: false,
                    crew_portal_editable: false,
                },
                loading: true,
                document_url: ''
            }
        },

        mounted() {
            this.document_url = `${process.env.VUE_APP_PORTAL}/api/hr/employee/documents/${this.$route.params.document}/view?api_token=${auth.getToken()}&timestamp=${(new Date()).getTime()}`;
            this.onMounted();
        },

        methods: {
            navigateToEdit() {
                if (this.$route.params.type) {
                    this.$router.push('/documents/mandatory/' + this.$route.params.type + '/edit');
                } else {
                    this.$router.push('/documents/' + this.document.id + '/edit');
                }
            },

            getIcon() {
                if (this.document.type === 'Passport') {
                    return 'fa-passport';
                } else if (this.document.type === 'Contract of Employment') {
                    return 'fa-file-signature';
                } else {
                    return 'fa-file';
                }
            },

            onMounted() {
                if (this.$route.params.type) {
                    this.$api('hr').get(`employee/documents/mandatory/${this.$route.params.type}`)
                        .then(({data}) => {
                            this.loading = false;
                            this.document = data.data.document
                        })
                        .catch(() => {
                            this.$router.replace('/documents');
                        });
                } else {
                    this.$api('hr').get(`employee/documents/${this.$route.params.document}`)
                        .then(({data}) => {
                            this.loading = false;
                            this.document = data.data.document
                        })
                        .catch(() => {
                            this.$router.replace('/documents');
                        });
                }
            },
        },

        watch: {
            '$route'() {
                this.onMounted();
            },
        },
    }
</script>
